import StarRating from "@/components/base/StarRating";
import { sampleReviews } from "@/mocks/reviews";

export default function Reviews() {
  return (
    <section className="mt-14">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">顾客评价</h2>
        <div className="flex items-center gap-2 text-sm text-foreground-500">
          <StarRating rating={4.8} />
          <span>共 1,286 条评价</span>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
        {sampleReviews.map((r) => (
          <article key={r.name} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-center gap-3">
              <img
                src={r.avatar}
                alt={`${r.name} 的用户头像`}
                title={`${r.name} - 美味的快递用户评价`}
                className="h-10 w-10 rounded-full object-cover"
              />
              <div>
                <p className="font-heading text-sm font-bold text-foreground-950">{r.name}</p>
                <p className="text-xs text-foreground-400">{r.date}</p>
              </div>
            </div>
            <div className="mt-3">
              <StarRating rating={r.rating} size="text-xs" showValue={false} />
            </div>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{r.content}</p>
            <div className="mt-3 flex flex-wrap gap-1.5">
              {r.tags.map((t) => (
                <span key={t} className="rounded-full bg-background-100 px-2.5 py-0.5 text-xs text-foreground-600">
                  {t}
                </span>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}